<template>
  <div class="AssignTaskModal">
    <div class="assign-task-modal" ref="assignRefModel">
      <a-modal
        v-model="isShow"
        title="批量指派工单"
        @ok="handleOk"
        :maskClosable="false"
        centered
        width="551px"
        :getContainer="() => $refs.assignRefModel"
        @cancel="handleCancel"
        cancelText="取消"
        okText="确定"
        :afterClose="() => $refs.ruleForm.resetFields()"
      >
        <a-form-model
          :model="assignForm"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          ref="ruleForm"
          :rules="rules"
          :colon="false"
        >
          <a-form-model-item label="指派区域经理/服务工程师" prop="uid">
            <a-select
              placeholder="请选择区域经理/服务工程师"
              v-model="assignForm.uid"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in allSaleList"
                :key="index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="限定完成日">
            <div class="deadline">
              <span
                v-for="(item, index) in deadline"
                :key="index"
                @click="selectDate(item, index)"
                :class="active == index ? 'active' : ''"
                >{{ item.name }}</span
              >
              <div @click="isOpen = !isOpen">
                <a-date-picker
                  @change="dateChange"
                  :value="assignForm.nextVistDay"
                  :open="isOpen"
                />
              </div>
            </div>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "AssignTaskModal",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    allSaleList: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  components: {},

  data() {
    return {
      // 是否显示
      isShow: false,
      // 表单对象
      assignForm: {
        nextVistDay: null,
        uid: undefined,
      },
      labelCol: { span: 9 },
      wrapperCol: { span: 14, offset: 1 },
      rules: {
        uid: [
          {
            required: true,
            message: "请选择区域经理/服务工程师",
            trigger: "blur",
          },
        ],
        // nextVistDay: [
        //   { required: true, message: "请选择限定完成日", trigger: "blur" },
        // ],
      },
      // 限定时间
      deadline: [
        { name: "明日", time: 1 },
        { name: "7天", time: 7 },
        { name: "30天", time: 30 },
        { name: "其他" },
      ],
      // 限定完成日激活状态
      active: null,
      isOpen: false,
    };
  },

  methods: {
    dateChange(date, dateStr) {
      this.isOpen = false;
      if (dateStr) {
        this.active = 3;
        this.assignForm.nextVistDay = moment(dateStr, "YYYY-MM-DD");
      } else {
        this.active = null;
        this.assignForm.nextVistDay = null;
      }
      this.$refs["ruleForm"].clearValidate("nextVistDay");
    },
    // 选择限定完成日
    selectDate(item, index) {
      this.active = index;
      const date = this.getLaterDate(item.time);
      if (index == 3) {
        this.assignForm.nextVistDay = null;
        this.isOpen = true;
      } else {
        this.isOpen = false;
        this.assignForm.nextVistDay = moment(date, "YYYY-MM-DD");
        console.log(this.assignForm.nextVistDay);
      }
    },
    // 根据天数计算时间
    getLaterDate(dayNum, dateTime = null) {
      // 如果为null,则格式化当前时间为时间戳
      if (!dateTime) dateTime = +new Date();
      // 如果dateTime长度为10或者13，则为秒和毫秒的时间戳，如果超过13位，则为其他的时间格式
      if (dateTime.toString().length == 10) dateTime *= 1000;
      const timestamp = +new Date(Number(dateTime));

      const one_day = 86400000; // 24 * 60 * 60 * 1000;
      const addVal = dayNum * one_day + timestamp;
      //x天后的日期
      const date = new Date(addVal);

      //格式化日期
      const filters = (n) => {
        return n < 10 ? (n = "0" + n) : n;
      };
      const month = filters(date.getMonth() + 1);
      const day = filters(date.getDate());
      const hours = filters(date.getHours());
      const minutes = filters(date.getMinutes());
      const seconds = filters(date.getSeconds());

      const lastTime = `${date.getFullYear()}-${month}-${day}`;

      return lastTime;
    },
    // 确认
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.isOpen = false;
          this.$emit("ok", this.assignForm);
        }
      });
    },
    handleCancel() {
      this.isOpen = false;
      this.assignForm = {
        nextVistDay: null,
        uid: undefined,
      };
      this.$emit("cancel");
    },
  },
  watch: {
    visible(val) {
      this.isShow = val;
    },
  },
};
</script>

<style scoped lang="scss">
.assign-task-modal::v-deep {
  .ant-modal-header {
    .ant-modal-title {
      text-align: center !important;
    }
  }
  .ant-modal-body {
    text-align: center;
    .ant-form-item {
      margin-bottom: 10px;
      .ant-form-item-control {
        text-align: left;
        .ant-select {
          width: 224px;
        }
      }

      .deadline {
        display: flex;
        align-items: center;
        span {
          margin-right: 16px;
        }
        .active {
          color: #83ba7b;
        }
      }
      .ant-calendar-picker {
        margin-right: 0 !important;
        .ant-input {
          width: 116px;
        }
      }
    }
  }
  .ant-modal-footer {
    text-align: center;
    padding-bottom: 44px;
    border: 0;
    div button {
      width: 72px;
      height: 32px;
      &:nth-child(2) {
        margin-left: 80px;
        background: #83ba7b;
        border: 0;
      }
    }
  }
}
</style>
